import {
  MATCH_STATUSES,
  NEW_MATCHES,
  CURRENT_MATCHES,
  PAST_MATCHES,
} from '@/constants/match-statuses';

import capitalize from '@/filters/capitalize';

export function getQuestion (status, type = 'default', params = {}) {
  if (!status.questions || !status.questions[type]) { return; }
  let question = status.questions[type];

  // Replace placeholders in question with param values
  Object.keys(params).forEach((key) => {
    const replacement = params[key];
    const search = `{{${key}}}`;
    question = question.split(search).join(replacement);
  });

  return question;
}

export function getNextQuestion (status, type = 'default', params = {}) {
  const nextStatus = status.next[0];
  return nextStatus ? getQuestion(nextStatus, type, params) : '';
}

export function createMatchStatus (data) {
  const statusDetails = MATCH_STATUSES[data];

  return {
    ...statusDetails,
    next: statusDetails.next.map(createMatchStatus),
    isLeaf: !statusDetails.next.length,
    // creates `isX` flags for all statuses
    ...Object.keys(MATCH_STATUSES)
      .reduce((acc, name) => ({
        ...acc,
        [`is${capitalize(name)}`]: statusDetails.name === name,
      }), {}),
    isNew: NEW_MATCHES.statuses.some(status => statusDetails.name === status),
    isCurrent: CURRENT_MATCHES.statuses.some(status => statusDetails.name === status),
    isPast: PAST_MATCHES.statuses.some(status => statusDetails.name === status),
  };
}
